import React from 'react';
// import __ from 'lodash';
 
class DropdownSekolah extends React.Component {
    render() {
        return (
            this.props.sekolah.map(val =>
                <option key={val.ID_SEKOLAH} value={val.ID_SEKOLAH}>{val.NAMA_SEKOLAH}</option>
            )
        )
    }
}

export default DropdownSekolah;